import { defineMessages } from 'react-intl';

const point11Messages = defineMessages({
    wallpoint: {
        id: 'wall-point-point11',
        defaultMessage: 'Wallpoint',
    },
    shaft: {
        id: 'shaft-point11',
        defaultMessage: 'Shaft',
    },
    cabinet: {
        id: 'cabinet-point11',
        defaultMessage: 'Cabinet',
    },
    pop: {
        id: 'pop-point11',
        defaultMessage: 'PoP',
    },
    pillar: {
        id: 'pillar-point11',
        defaultMessage: 'Pillar',
    },
    linecut: {
        id: 'linecut-point11',
        defaultMessage: 'Line Cut',
    },
    fork: {
        id: 'fork-point11',
        defaultMessage: 'Fork',
    },
    undefined: {
        id: 'undefined-point',
        defaultMessage: 'Undefined',
    },
    ups: {
        id: 'ups-asset',
        defaultMessage: 'UPS',
    },
    generator: {
        id: 'generator-asset',
        defaultMessage: 'Generator',
    },
});

export default point11Messages;
